export enum DocumentListActionDispatchTypes {
  GET_DOCUMENT_LIST_ERROR = "GET_DOCUMENT_LIST_ERROR",
  GET_DOCUMENT_LIST_INVOKE = "GET_DOCUMENT_LIST_INVOKE",
  GET_DOCUMENT_LIST_SUCCESS = "GET_DOCUMENT_LIST_SUCCESS",
  GET_DOCUMENT_LIST_RESET = "GET_DOCUMENT_LIST_RESET",
}

export enum DocumentDownloadDispatchTypes {
  GET_DOCUMENT_DOWNLOAD_ERROR = "GET_DOCUMENT_DOWNLOAD_ERROR",
  GET_DOCUMENT_DOWNLOAD_INVOKE = "GET_DOCUMENT_DOWNLOAD_INVOKE",
  GET_DOCUMENT_DOWNLOAD_RESET = "GET_DOCUMENT_DOWNLOAD_RESET",
  GET_DOCUMENT_DOWNLOAD_SUCCESS = "GET_DOCUMENT_DOWNLOAD_SUCCESS",
}

export enum DocumentTypes {
  PDF = "pdf",
  DOC = "msword",
  DOCX = "vnd.openxmlformats-officedocument.wordprocessingml.document",
  PNG = "png",
  JPEG = "jpeg",
  JPG = "jpg",
  INVALID = "",
}

export enum DocumentTabType {
  DOCUMENT = 1,
  ATTACH_LETTER = 2,
}

export const InboundDocumentationHeaderLabel = [
  {
    label: "DOCUMENT NAME",
    width: "20%",
  },
  {
    label: "RECEIVED DATE/TIME",
    width: "20%",
  },
  {
    label: "DOC TYPE",
    width: "60%",
  },
];

export const Source = {
  FAX: "Fax",
  INBOUND: "Inbound",
  EMAIL: "Email",
};

export const LetterDescisionHeaderLabel = [
  {
    label: "DOCUMENT NAME",
    width: "20%",
  },
  {
    label: "MAILED DATE/TIME",
    width: "20%",
  },
  {
    label: "DOC TYPE",
    width: "60%",
  },
];

export const AuthHistoryHeaderLabel = [
  {
    label: "AUTH ID",
    width: "10%",
  },
  {
    label: "HEALTH PLAN",
    width: "13%",
  },
  {
    label: "SUBSCRIBER ID",
    width: "8%",
  },
  {
    label: "STATUS",
    width: "8%",
  },
  {
    label: "SERVICE PROVIDER",
    width: "8%",
  },
  {
    label: "ADMIT DATE",
    width: "8%",
  },
  {
    label: "DISCHARGE DATE",
    width: "8%",
  },
  {
    label: "TOTAL APPROVED",
    width: "11%",
  },
  {
    label: "SN",
    width: "4%",
  },
  {
    label: "PT",
    width: "4%",
  },
  {
    label: "OT",
    width: "4%",
  },
  {
    label: "ST",
    width: "4%",
  },
  {
    label: "MSW",
    width: "4%",
  },
  {
    label: "HHA",
    width: "4%",
  },
];
